import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { ICommonQueryParams } from '@/types';
import {
  createCurrency as createCurrencyApi,
  deleteCurrency as deleteCurrencyApi,
  getCurrencyList as getCurrencyListApi,
  updateCurrency as updateCurrencyApi,
} from '../api';
import { queryKey } from '../constants';
import { ICurrencyForm } from '../types';

export const useCurrencyList = ({
  queryParams,
  enabled,
}: {
  queryParams: ICommonQueryParams;
  enabled: boolean;
}) => {
  return useQuery({
    queryKey: [queryKey.getExchangeRateList, queryParams],
    queryFn: () => getCurrencyListApi(queryParams),
    enabled,
  });
};

export const useCreateCurrency = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ICurrencyForm) => createCurrencyApi(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey.getExchangeRateList] });
      toast.success('Currency created successfully');
    },
  });
};

export const useUpdateCurrency = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: Partial<ICurrencyForm> }) =>
      updateCurrencyApi({ id, payload }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey.getExchangeRateList] });
      toast.success('Currency updated successfully');
    },
  });
};

export const useDeleteCurrency = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteCurrencyApi(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey.getExchangeRateList] });
      toast.success('Currency deleted successfully');
    },
  });
};
